export const MOCK_CUSTOMER_ID = 'customer-demo-id';
export const MOCK_REQUESTED_USAGE = 10;
